import { defineRouting } from 'next-intl/routing'

export type AvailableLocale = {
  label: string
  code: string
  flag: string
}

// Array of locales with label, code and flag icon
export const availableLocales: AvailableLocale[] = [
  { label: 'Français', code: 'fr', flag: '🇫🇷' },
  { label: 'Nederlands', code: 'nl', flag: '🇳🇱' },
  { label: 'English', code: 'en', flag: '🇬🇧' },
]

export const fallbackLanguage = 'FR'
export const SUPPORTED_LANGUAGES = ['FR', 'EN', 'NL']

export const routing = defineRouting({
  locales: availableLocales.map((locale) => locale.code),
  defaultLocale: 'fr',
  localePrefix: {
    mode: 'always',
    prefixes: {
      fr: '/fr',
      en: '/en',
      nl: '/nl',
    },
  },
})
